export default __webpack_public_path__ + "static/media/evenShotBg.381507dc.png";